import React from 'react';
import { Input, Label, ErrorText } from '../lib';

const FormInput = React.forwardRef((props, ref) => {
    const { label, style, error, ...rest } = props;
    
    return (
        <div style={{ ...style, marginBottom: '10px', width: '100%' }}>
            {label && <Label htmlFor={rest.name}>{label}</Label>}
            <Input 
                ref={ref}
                {...rest}
                style={error && { border: 'solid 1px red' }}
            />
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
})

// FormInput.defaultProps = {
//         type: "text",
//         className: ""
//     }

// FormInput.propTypes = {
//         name: PropTypes.string.isRequired,
//         placeholder: PropTypes.string,
//         type: PropTypes.oneOf(['text', 'number', 'email', 'password']),
//         className: PropTypes.string,
//         value: PropTypes.any,
//         onChange: PropTypes.func.isRequired
//     }

export default React.memo(FormInput);